<template lang="pug">
  .event-form(v-if="recaptchaSiteKey")
    //- loading(:active="loading" :is-full-page="false" :height="40" :width="40" color="#000000")
    .loading.flex(v-if="loading")
      Spinner(:size="16" :thickness="3")
    validation-observer(v-slot="{ invalid }" ref="form")
      form(@submit.prevent="submit")
        .columns
          .form-field
            validation-provider(name="Vorname" rules="required" v-slot="{ errors }")
              label.label(for="first-name" :class="`is-${size}`") Vorname
              .control.has-icons-right
                input#first-name.input(
                  type="text"
                  name="first_name"
                  v-model="form.booker.first_name"
                  :class="[ `is-${size}`, { 'is-danger': errors && errors.length } ]"
                )
                span.icon.is-small.is-right(:class="`is-${size}`")
                  font-awesome-icon(icon="user")
              p.help.is-danger(v-if="errors && errors.length" :class="`is-${size}`") {{ errors[0] }}
              p.help.has-text-grey(v-else :class="`is-${size}`") Pflichtfeld
          .form-field
            validation-provider(name="Nachname" rules="required" v-slot="{ errors }")
              label.label(for="last-name" :class="`is-${size}`") Nachname
              .control.has-icons-right
                input#last-name.input(
                  type="text"
                  name="last_name"
                  v-model="form.booker.last_name"
                  :class="[ `is-${size}`, { 'is-danger': errors && errors.length } ]"
                )
                span.icon.is-small.is-right(:class="`is-${size}`")
                  font-awesome-icon(icon="user")
              p.help.is-danger(v-if="errors && errors.length" :class="`is-${size}`") {{ errors[0] }}
              p.help.has-text-grey(v-else :class="`is-${size}`") Pflichtfeld
        .columns
          .form-field
            validation-provider(name="E-Mail Adresse" rules="required|email" v-slot="{ errors }")
              label.label(for="email" :class="`is-${size}`") E-Mail Adresse
              .control.has-icons-right
                input#email.input(
                  type="email"
                  name="email"
                  v-model="form.booker.email"
                  :class="[ `is-${size}`, { 'is-danger': errors && errors.length } ]"
                )
                span.icon.is-small.is-right(:class="`is-${size}`")
                  font-awesome-icon(icon="envelope")
              p.help.is-danger(v-if="errors && errors.length" :class="`is-${size}`") {{ errors[0] }}
              p.help.has-text-grey(v-else :class="`is-${size}`") Pflichtfeld
          .form-field
            label.label(for="phone" :class="`is-${size}`") Telefon
            .control.has-icons-right
              input#phone.input(type="text" v-model="form.booker.phone" :class="`is-${size}`")
              span.icon.is-small.is-right(:class="`is-${size}`")
                font-awesome-icon(icon="phone")
        .form-field
          label.label(for="message" :class="`is-${size}`") Ihre Nachricht
          .control
            textarea.textarea(
              name="message"
              v-model="form.message"
              :class="`is-${size}`"
            )
        .columns
          .form-field
            validation-provider(name="Datenschutzbestimmungen" :rules="{ required: { allowFalse: false } }" v-slot="{ errors }")
              .control
                label.checkbox(:class="`is-${size}`")
                  //- input(
                  //-   type="checkbox"
                  //-   name="terms"
                  //-   v-model="form.terms"
                  //-   :class="{ 'is-danger': errors && errors.length }"
                  //- )
                  p-check(
                    name="terms"
                    color="dark"
                    v-model="form.terms"
                  )
                  |  Ich stimme den Datenschutzbestimmungen zu
              p.help.is-danger(v-if="errors && errors.length" :class="`is-${size}`") {{ errors[0] }}
              p.help.has-text-grey(v-else :class="`is-${size}`") Pflichtfeld
          .form-field.text-right
            .control
              button.button.is-pulled-right.is-primary(type="submit" :disabled="invalid") Anmelden
              .clearfix
  .event-form(v-else)
    .notification
      strong Es gibt ein technisches Problem!
      p Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.
</template>

<script>
import Vue from 'vue';
import uniqid from 'uniqid';

import { mapGetters, mapMutations, mapActions } from 'vuex';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

// import Loading from 'vue-loading-overlay';

import countries from 'i18n-iso-countries';
import de from 'i18n-iso-countries/langs/de.json';

countries.registerLocale(de);

export default {
    name: 'EventForm',
    props: {
        data: {
            type: Object,
            required: true
        },
        size: {
            type: String,
            default: 'normal',
            validator: val => ['small', 'normal', 'medium', 'large'].includes(val)
        }
    },
    data: () => ({
        loading: false,
        form: {
            booker: {
                first_name: '',
                last_name: '',
                email: '',
                phone: ''
            },
            message: '',
            terms: false
        }
    }),
    components: {
        ValidationObserver,
        ValidationProvider
    },
    computed: {
        ...mapGetters({
            recaptchaSiteKey: 'googleRecaptchaSiteKey'
        })
    },
    methods: {
        async submit() {
            const valid = await this.$refs.form.validate();
            if (valid && this.recaptchaSiteKey) {
                this.loading = true;
                try {
                    await this.$recaptchaLoaded();
                    await this.$recaptcha('event');

                    const payload = {
                        event: this.data.event.name,
                        message: this.form.message,
                        slot: { id: this.data.id },
                        booker: this.form.booker
                    };
                    this.createBooking(payload)
                        .then(() => {
                            // TODO:
                            // 1. show success message
                            // 2. clear form
                            // 3. increment booked number in slot

                            const message = {
                                id: uniqid(),
                                title: 'Erfolgreich',
                                text: 'Ihre Anmeldung wurde erfolgreich versendet.',
                                type: 'success',
                                autoclose: 5000
                            };
                            this.addMessage(message);

                            this.form = {
                                // event: undefined,
                                // slot: undefined,
                                // member: undefined,
                                booker: {
                                    first_name: '',
                                    last_name: '',
                                    email: '',
                                    phone: ''
                                },
                                message: '',
                                terms: false
                            };

                            this.$refs.form.reset();

                            this.$emit('success');
                        })
                        .catch(() => {
                            const message = {
                                id: uniqid(),
                                title: 'Fehler',
                                text: 'Ihre Anmeldung konnte nicht verarbeitet werden.',
                                type: 'danger',
                                autoclose: 5000
                            };
                            this.addMessage(message);

                            this.$emit('error');
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } catch (error) {
                    console.error(error);
                    const message = {
                        id: uniqid(),
                        title: 'Fehler',
                        text: `
                Es gibt ein technisches Problem.<br>
                Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.
            `,
                        type: 'danger',
                        autoclose: 5000
                    };
                    this.addMessage(message);
                    this.loading = false;

                    this.$emit('error');
                }
            }
        },
        ...mapMutations({
            addBookingToSlot: 'event/addBookingToEventSectionSlot'
        }),
        ...mapActions({
            createBooking: 'event/createBooking',
            addMessage: 'message/add'
            // refreshMenuItem: 'refreshMenuItem',
        })
    },
    beforeMount() {
        if (this.recaptchaSiteKey) {
            Vue.use(VueReCaptcha, {
                siteKey: this.recaptchaSiteKey,
                loaderOptions: {
                    useRecaptchaNet: true
                }
            });
        }
    }
};
</script>

<style lang="sass" scoped>
.event-form
  position: relative
  margin-top: 2rem
  .no-margin
    margin-bottom: 0
  .no-padding
    padding-bottom: 0
</style>
